//accepted list of emails
const university = "Arizona State University";
const validDomain = "asu.edu";

//Colors for a particular theme
const Primary = '#ffc425';
const Secondary = "#8c1d40";
const DeleteColor = "#8c1d40";
const NavColor = "#353535";

export {DeleteColor, Secondary, NavColor,university, validDomain};
export default Primary;


// WEBPACK FOOTER //
// ./src/Theme.js